class CartRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);
    
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('cart-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        // Only now is "empty" meaningful. Flagging it before the fetch would
        // let CSS hide the element, and a display:none node never intersects,
        // so the observer above would never have fired in the first place.
        if (!this.querySelector('.mini-cart__navigation li')) {
          this.classList.add('is-empty');
        }
      })
      .catch(e => {
        this.classList.add('is-empty');
        console.error(e);
      });
  }
}
customElements.define('cart-recommendations', CartRecommendations);